import { CopilotControlAuditPanelContextDefinition } from 'components/Copilot/ControlAudit/copilotControlAuditPanelContextDefinition';
import { CopilotPanelContext } from 'models/copilot/copilotBridge';

export class CopilotControlEvidenceAuditPanelContextDefinition extends CopilotControlAuditPanelContextDefinition {
  constructor() {
    super();
    this.context = CopilotPanelContext.ControlEvidenceAudit;
    this.name = 'ControlEvidenceAudit';
  }
}
